import React from "react";

export default function ProcessHistory({ rows = [] }) {
  if (!rows.length) {
    return (
      <div className="crm-alert-load-error" role="status">
        <span className="crm-alert-load-error__icon" aria-hidden="true">!</span>
        <span>Todavía no hay gestiones registradas.</span>
      </div>
    );
  }

  return (
    <div className="process-action-modal-v2__history-wrap">
      <table className="process-action-modal-v2__history-table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Canal</th>
            <th>Resultado</th>
            <th>Número</th>
            <th>Duración</th>
            <th>Observación</th>
            <th>Evidencia</th>
            <th>Estado nuevo</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((item) => (
            <tr key={item.id}>
              <td>{item.fecha || "-"}</td>
              <td>{item.canal || "-"}</td>
              <td>{item.resultado || "-"}</td>
              <td>{item.numeroContactado || "-"}</td>
              <td>{item.duracionSegundos ? `${item.duracionSegundos} seg.` : "-"}</td>
              <td>{item.observacion || "-"}</td>
              <td>{item.evidenciaReferencia || "-"}</td>
              <td>{item.estadoNuevo || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
